module.exports = __webpack_public_path__ + "img/googleicon.8aff6dd5.png";